// Both skip links reveal themselves on `:focus` (see SkipToContent.scss / AppSideNav.scss).
// Browsers restore `document.activeElement` across soft reloads and bfcache restores, and per
// spec a focus the user didn't initiate still matches `:focus-visible` while the page has seen
// no interaction — so `:focus-visible` alone does not keep a restored focus from painting the
// bar across the top of the page on load. Drop that focus instead.

type SkipToContent = {
  selector: string;
  blurRestoredFocus: () => void;
  init: () => void;
};

const SkipToContent: SkipToContent = {
  selector: 'a.skip-to-content, .app-side-nav__skip-to-content',

  blurRestoredFocus: () => {
    const active = document.activeElement;
    if (active instanceof HTMLElement && active.matches(SkipToContent.selector)) {
      active.blur();
    }
  },

  init: () => {
    SkipToContent.blurRestoredFocus();
  },
};

// Bound at module scope rather than in `init()`: `app.js` runs at the end of `<body>`, so this
// listener is attached before `DOMContentLoaded` fires and well before `App.init()` — which is
// what keeps a bfcache restore from flashing the bar before the handler exists.
window.addEventListener('pageshow', SkipToContent.blurRestoredFocus);

export default SkipToContent;
